import { Injectable } from '@angular/core';
import { PermissionsTableItem } from '@macs-frontend/features/shared/models/permissions-table-item';
import { Observable } from 'rxjs';
import { ApiService } from '../../../../core';

@Injectable({
  providedIn: 'root',
})
export class PermissionsApiService extends ApiService {
  getAllPermissions(): Observable<PermissionsTableItem[]> {
    return this.http.get<PermissionsTableItem[]>(
      `${this.API_PATH}/company_management/manage/users/allPermissions`,
    );
  }
}
